import React from 'react';
import PropTypes from 'prop-types';
import ExpandedRow from './ExpandedRow';

const ExpandedRowRenderer = ({ record, rowErrors, t }) => {
  const errors = rowErrors[record.goSearchResponseRowId];
  return <ExpandedRow errors={errors} t={t} />;
};

ExpandedRowRenderer.propTypes = {
  t: PropTypes.func.isRequired,
  record: PropTypes.shape({
    goSearchResponseRowId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
  }).isRequired,
  rowErrors: PropTypes.objectOf(PropTypes.any).isRequired, // object with rowId keys
};

export default React.memo(ExpandedRowRenderer);
